import React, { useState, useEffect } from 'react';
import Button from '../../../../../ui/canon/Button';
import { SendIcon } from 'lucide-react';

const PercentageSliderWidget = ({
  onAnswer,
  disabled,
  min = 0,
  max = 100,
  step = 1,
  defaultValue = 50,
  label = 'Percentage',
  initialValue = null,
}) => {
  const getInitialValue = () => {
    if (initialValue !== null && initialValue !== undefined) {
      return typeof initialValue === 'number' ? initialValue : Number(initialValue) || defaultValue;
    }
    return defaultValue;
  };

  const [value, setValue] = useState(getInitialValue);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setValue(getInitialValue());
    setIsSubmitting(false);
  }, [initialValue]);

  const handleSubmit = () => {
    if (!isSubmitting) {
      setIsSubmitting(true);
      onAnswer({ value: value, formatted: `${value}%` });
    }
  };

  const handleSliderChange = (e) => {
    setValue(Number(e.target.value));
  };

  const percentage = ((value - min) / (max - min)) * 100;

  return (
    <div className="space-y-6 w-full max-w-md">
      <div className="flex items-end justify-between">
        <span className="text-sm font-medium text-succession-text-secondary">{label}</span>
        <span className="text-3xl font-bold text-succession-text-primary">
          {value}%
        </span>
      </div>

      <div className="relative w-full h-6 flex items-center">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={handleSliderChange}
          disabled={disabled || isSubmitting}
          className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-succession-primary focus:outline-none focus:ring-2 focus:ring-succession-focus-ring"
          style={{
            background: `linear-gradient(to right, var(--succession-primary, #000) 0%, var(--succession-primary, #000) ${percentage}%, #e5e7eb ${percentage}%, #e5e7eb 100%)`
          }}
        />
      </div>

      <div className="flex justify-between text-xs text-succession-text-muted">
        <span>{min}%</span>
        <span>{max}%</span>
      </div>

      <Button
        onClick={handleSubmit}
        disabled={disabled || isSubmitting}
        className="w-full"
      >
        <SendIcon className="h-4 w-4 mr-2" />
        Submit Answer
      </Button>
    </div>
  );
};

export default PercentageSliderWidget;
